import SubmitButton from '@/components/forms/SubmitButton'
import TextInput from '@/components/forms/TextInput'
import type {ReactElement} from 'react'
import {Dialog, Transition} from '@headlessui/react'

import {PhoneNumberUtil, PhoneNumberFormat} from 'google-libphonenumber'
import {Fragment} from 'react'
import React from 'react'
import {Formik, Form, FormikHelpers} from 'formik'
import {useRouter} from 'next/router'
import toast from 'react-hot-toast'
import CustomToast from '@/components/CustomToast'
import {ForgotValues, NewPassSchema, NewPassValues} from '../../../forms/Forgot'
import {useMutation} from 'react-query'
import {
  ForgotPassword,
  ForgotPasswordEmail,
  PasswordReset,
  ForgotPasswordWhatsapp
} from '@/services/api/auth'
import {VerificationData, VerificationDataOptional} from '@/types'
import ForgotLoginPhoneForm from '../ForgotLoginPhoneForm'
import BackButton from '@/components/BackButton'
import allAlerts from '@/config/alerts.json'
import useAuth from '@/hooks/useAuth'
import { useTranslation } from 'next-i18next'
type ForgotViewProps = {
    currentView: string
    headingNumber: string | null
    shouldVerify: boolean
    setShouldVerify: React.Dispatch<React.SetStateAction<boolean>>
    verificationData: VerificationData | undefined
    setVerificationData: React.Dispatch<React.SetStateAction<VerificationData | undefined>>
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
    VerificationError: any
    setVerificaitonError: React.Dispatch<React.SetStateAction<any>>
    handleVerification: any
    setVerificationError: any
    isOpen: boolean
    setCurrentView: any
    postLoginCallBack: any
    setPostLoginCallBack: any
    executePostLoginCallback: () => void
    setProductType: any
    onButtonClick: (e: React.MouseEvent, action: () => void) => void // Add this prop
}

const ForgotPhoneInput = React.memo(({
  locale,
  tCommon,
  handleSubmitPhone,
  mutation,
  setIso2
}: any) => {
  return (
    <>
      <div>
        <p className={`font-bold ${locale === 'ar' ? 'text-right' : 'text-left'}`}>
          {tCommon('phoneHeading')}
        </p>
      </div>
      <ForgotLoginPhoneForm
        handleSubmitPhone={handleSubmitPhone}
        mutation={mutation}
        setIso2={setIso2}
      />
    </>
  )
})
ForgotPhoneInput.displayName = "ForgotPhoneInput"
const ForgotView = (
    {
        currentView,
        headingNumber,
        verificationData,
        shouldVerify,
        setShouldVerify,
        setIsOpen,
        setVerificationData,
        VerificationError,
        setVerificaitonError,
        handleVerification,
        setVerificationError,
        isOpen,
        setCurrentView,
        postLoginCallBack,
        setPostLoginCallBack,
        executePostLoginCallback,
        setProductType,
        onButtonClick // Add this prop
    }: ForgotViewProps
) => {
    const { login, isLoading } = useAuth('none')
    const {t: tCommon} = useTranslation('common')
    const {t: tAlerts} = useTranslation('alerts')
    const {locale} = useRouter()
    const alerts = allAlerts[locale as keyof typeof allAlerts] || allAlerts?.ar;
    const closeModal = () => {
    setTimeout(() => {
      setIsOpen(false)
    }, 500)
  }
  const mutation = useMutation(ForgotPassword)
  const Emailmutation = useMutation(ForgotPasswordEmail)
  const Whatsappmutation = useMutation(ForgotPasswordWhatsapp)
  const passMutation = useMutation(PasswordReset)
  const [tab, setTab] = React.useState<'forgot' | 'new-pass'>('forgot')
  const [currentMethod, setCurrentMethod] = React.useState<'phone' | 'email' | 'whatsapp'>('phone')
  const [forgotData, setForgotData] = React.useState<
    VerificationDataOptional | undefined
  >()

  const [seconds, setSeconds] = React.useState(60)

  const [iso2, setIso2] = React.useState('IL')
  React.useEffect(() => {
    const countdown = setInterval(() => {
      setSeconds(prevSeconds => prevSeconds - 1)
    }, 1000)

    if (seconds === 0) {
      clearInterval(countdown)
    }

    return () => clearInterval(countdown)
  }, [seconds])

  const [message, setMessage] = React.useState(
    `${tCommon('forgotMessage')}`,
  )

  const handleSubmitPhone = (
    values: ForgotValues,
    actions: FormikHelpers<ForgotValues>,
  ) => {
    const phoneUtil = PhoneNumberUtil.getInstance()
    const parsedNumber = phoneUtil.parseAndKeepRawInput(values.phone, iso2)
    const isValid = phoneUtil.isValidNumber(parsedNumber)

    if (!isValid) {
      actions.setFieldError('phone', 'Phone Number is Invalid')
      return
    }
    mutation.mutate(
      {phone: values.phone, country_code: values.country_code},
      {
        onSuccess(data: any) {
          toast.custom((t) => <CustomToast t={t} message={tAlerts('verification_code_phone')} type="success" />, {
            duration: 2500,
          });
          setMessage(`${tCommon('enterCodeHeading')}`)
          setForgotData({
            phone: {
              number: values.phone,
              country_code: values.country_code,
            },
          })
          setSeconds(60)
          setTab('new-pass')
        },
        onError(error: any) {
          if (error.response.status === 500) {
            actions.setFieldError('email', 'An Error Occurred')
            toast.custom((t) => <CustomToast t={t} message={'Error Occurred'} type="error" />, {
              duration: 4000,
            });
          } else {
            toast.custom((t) => <CustomToast t={t} message={error.response.data.message} type="error" />, {
              duration: 4000,
            });
          }
        },
      },
    )
  }

  const handleResendEmail = (phone: any) => {
    Emailmutation.mutate(
      {
        country_code: phone.country_code,
        phone: phone.number,
      },
      {
        onSuccess() {
          setSeconds(60)
          toast.custom((t) => <CustomToast t={t} message={tAlerts('forgot_code')} type="success" />, {
              duration: 4000,
          });
        },
        onError(error: any) {
          toast.custom((t) => <CustomToast t={t} message={error.response.data.message} type="error" />, {
              duration: 4000,
            id: 'Validation Error',
          });
        },
      },
    )
  }
  const handleResendWhatsapp = (phone: any) => {
    Whatsappmutation.mutate(
      {
        country_code: phone.country_code,
        phone: phone.number,
      },
      {
        onSuccess() {
          setSeconds(60)
          toast.custom((t) => <CustomToast t={t} message={alerts.forgot_code} type="success" />, {
              duration: 4000,
          });
        },
        onError(error: any) {
          toast.custom((t) => <CustomToast t={t} message={error.response.data.message} type="error" />, {
              duration: 4000,
            id: 'Validation Error',
          });
        },
      },
    )
  }
  const handleResendPhone = (phone: any) => {
    mutation.mutate(
      {
        country_code: phone.country_code,
        phone: phone.number,
      },
      {
        onSuccess() {
          setSeconds(60)
          toast.custom((t) => <CustomToast t={t} message={tAlerts('forgot_code')} type="success" />, {
              duration: 4000,
          });
        },
        onError(error: any) {
          toast.custom((t) => <CustomToast t={t} message={error.response.data.message} type="error" />, {
              duration: 4000,
              id: 'Validation Error',
          });
        },
      },
    )
  }
  const handleSubmitNew = (
    values: NewPassValues,
    actions: FormikHelpers<NewPassValues>,
  ) => {
    passMutation.mutate(
      {
        forgot_code: values.code,
        password: values.password,
        phone: forgotData?.phone?.number ?? '',
        country_code: forgotData?.phone?.country_code ?? '',
      },
      {
        onSuccess(data: any) {
          setTimeout(() => {
            setIsOpen(false)
            setProductType(null);
            setCurrentView('login');
            if (postLoginCallBack) {
              postLoginCallBack();
              setPostLoginCallBack(undefined); // Clear callback
            }
          }, 500)
          setTab('forgot')
          toast.custom((t) => <CustomToast t={t} message={tAlerts('password_reset_success')} type="success" />, {
              duration: 4000,
          });
        },
        onError(error: any) {
          if (error.response.status === 404) {
            actions.setFieldError('code', alerts.code_failure)
            toast.custom((t) => <CustomToast t={t} message={tAlerts('code_failure')} type="error" />, {
              duration: 4000,
            });
          } else {
            toast.custom((t) => <CustomToast t={t} message={error.response.data.message} type="error" />, {
              duration: 4000,
            });
          }
        },
      },
    )
  }
    return(
        <div className="modal-content p-3 lg:p-6 xl:p-8 2xl:p-11" dir={`${locale === 'ar' ? 'rtl' : 'ltr'}`}>
                          {tab === 'forgot' && (
                            <div className="mb-6">
                              <ForgotPhoneInput
                                locale={locale}
                                tCommon={tCommon}
                                handleSubmitPhone={handleSubmitPhone}
                                mutation={mutation}
                                setIso2={setIso2}
                              />
                            </div>
                          )}
        
                          {tab === 'new-pass' && (
                            <div className="mb-6">
                              <>
                                <BackButton onClick={() => setTab('forgot')} />
                                <div className="mt-14 lg:mt-6 xl:mt-4">
                                  <p className={`font-bold ${locale === 'ar' ? 'text-right' : 'text-left'}`}>{message}</p>
                                </div>
                                <Formik
                                  initialValues={{
                                    password: '',
                                    code: '',
                                  }}
                                  validationSchema={NewPassSchema}
                                  onSubmit={handleSubmitNew}
                                  validateOnChange={false}
                                  validateOnBlur={false}>
                                  {({errors, touched}) => (
                                    <Form>
                                      <div className="form mt-4" dir={`${locale === 'ar' ? 'rtl' : 'ltr'}`}>
                                        <div className="form-group flex flex-col">
                                          <TextInput
                                            label={`${tCommon('phoneLabelForForgot')}`}
                                            type="text"
                                            name="code"
                                            placeholder={
                                              currentMethod === 'phone' 
                                                ? tCommon('enterCodePhone') 
                                                : tCommon('enterCodeEmail')
                                            }
                                            isError={errors.code && touched.code}
                                            error={errors.code}
                                          />
        
                                          {!mutation.isLoading ? (
                                            <div className="text-right text-sm">
                                              <a
                                                href="#"
                                                id="resend-phone"
                                                onClick={e => onButtonClick(e, () => {
                                                  setCurrentMethod('phone')
                                                  if (seconds == 0) {
                                                    handleResendPhone({
                                                      number: forgotData?.phone?.number,
                                                      country_code:
                                                        forgotData?.phone?.country_code,
                                                    })
                                                  }
                                                })}
                                                className={`block ${
                                                  seconds === 0
                                                    ? 'text-black'
                                                    : 'text-gray-500'
                                                }`}>
                                                {tCommon('resendPhone')} ({seconds}s)
                                              </a>
        
                                              <a
                                                href="#"
                                                id='resend-email'
                                                onClick={e => onButtonClick(e, () => {
                                                  if (seconds == 0) {
                                                    setCurrentMethod('email');
                                                    handleResendEmail({
                                                      number: forgotData?.phone?.number,
                                                      country_code:
                                                        forgotData?.phone?.country_code,
                                                    })
                                                  }
                                                })}
                                                className={`block mt-1 ${
                                                  seconds === 0
                                                    ? 'text-black'
                                                    : 'text-gray-500'
                                                }`}>
                                                {tCommon('resendEmail')} (
                                                {seconds}s)
                                              </a>

                                              <a
                                                href="#"
                                                onClick={e => onButtonClick(e, () => {
                                                  if (seconds == 0) {
                                                    setCurrentMethod('whatsapp');
                                                    handleResendWhatsapp({
                                                      number: forgotData?.phone?.number,
                                                      country_code:
                                                        forgotData?.phone?.country_code,
                                                    })
                                                  }
                                                })}
                                                className={`block mt-1 ${
                                                  seconds === 0
                                                    ? 'text-black'
                                                    : 'text-gray-500'
                                                }`}>
                                                أعد إرسال الرمز إلى الواتساب (
                                                {seconds}s)
                                              </a>
                                            </div>
                                          ) : (
                                            <svg
                                              className="animate-spin ml-1 mr-3 h-5 w-5 text-primary"
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                              viewBox="0 0 24 24">
                                              <circle
                                                className="opacity-25"
                                                cx="12"
                                                cy="12"
                                                r="10"
                                                stroke="currentColor"
                                                strokeWidth="4"></circle>
                                              <path
                                                className="opacity-75"
                                                fill="currentColor"
                                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                          )}
                                        </div>
                                        <div className="form-group mt-4 flex flex-col">
                                          <TextInput
                                            label={`${tCommon('enterNewPassword')}`}
                                            type="password"
                                            name="password"
                                            placeholder={`${tCommon('enterNewPasswordPlaceholder')}`}
                                            isError={
                                              errors.password && touched.password
                                            }
                                            error={errors.password}
                                          />
                                        </div>
                                        <SubmitButton
                                          isLoading={passMutation.isLoading}
                                          text={`${tCommon('forgotPasswordSubmit')}`}
                                          textType="string"
                                        />
                                      </div>
                                    </Form>
                                  )}
                                </Formik>
                              </>
                            </div>
                          )}
                        </div>
    )
}

export default ForgotView;